var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClass4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6717_2184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26757 18C5.12725 18 5.05785 17.8296 5.15825 17.7315L10.3788 12.6344C10.4254 12.5914 10.4513 12.5346 10.4513 12.4756C10.4513 12.4165 10.4254 12.3597 10.3788 12.3167L5.16129 7.26895C5.0602 7.17114 5.12944 7 5.2701 7H7.85651C7.89658 7.0011 7.93599 7.00924 7.97232 7.02395C8.00865 7.03866 8.04116 7.05962 8.06787 7.08556L13.4788 12.3167C13.5245 12.3577 13.55 12.4124 13.55 12.4694C13.55 12.5264 13.5245 12.5812 13.4788 12.6222L8.06787 17.8656C8.04783 17.9011 8.01813 17.932 7.98131 17.9554C7.94449 17.9788 7.90166 17.9941 7.85651 18H5.26757Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6717_2184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1509 18C10.0106 18 9.94121 17.8296 10.0416 17.7315L15.2622 12.6344C15.3087 12.5914 15.3346 12.5346 15.3346 12.4756C15.3346 12.4165 15.3087 12.3597 15.2622 12.3167L10.0447 7.26895C9.94356 7.17114 10.0128 7 10.1535 7H12.7399C12.7799 7.0011 12.8193 7.00924 12.8557 7.02395C12.892 7.03866 12.9245 7.05962 12.9512 7.08556L18.3622 12.3167C18.4078 12.3577 18.4333 12.4124 18.4333 12.4694C18.4333 12.5264 18.4078 12.5812 18.3622 12.6222L12.9512 17.8656C12.9312 17.9011 12.9015 17.932 12.8647 17.9554C12.8279 17.9788 12.785 17.9941 12.7399 18H10.1509Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6717_2184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0343 18C14.894 18 14.8246 17.8296 14.925 17.7315L20.1455 12.6344C20.1921 12.5914 20.218 12.5346 20.218 12.4756C20.218 12.4165 20.1921 12.3597 20.1455 12.3167L14.928 7.26895C14.8269 7.17114 14.8962 7 15.0368 7H17.6232C17.6633 7.0011 17.7027 7.00924 17.739 7.02395C17.7754 7.03866 17.8079 7.05962 17.8346 7.08556L23.2456 12.3167C23.2912 12.3577 23.3167 12.4124 23.3167 12.4694C23.3167 12.5264 23.2912 12.5812 23.2456 12.6222L17.8346 17.8656C17.8146 17.9011 17.7849 17.932 17.748 17.9554C17.7112 17.9788 17.6684 17.9941 17.6232 18H15.0343Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_6717_2184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.384266 18C0.243951 18 0.174551 17.8296 0.274948 17.7315L5.4955 12.6344C5.54207 12.5914 5.56798 12.5346 5.56798 12.4756C5.56798 12.4165 5.54207 12.3597 5.4955 12.3167L0.277992 7.26895C0.176898 7.17114 0.246135 7 0.386796 7H2.97321C3.01328 7.0011 3.05268 7.00924 3.08902 7.02395C3.12535 7.03866 3.15786 7.05962 3.18457 7.08556L8.59553 12.3167C8.64116 12.3577 8.66666 12.4124 8.66666 12.4694C8.66666 12.5264 8.64116 12.5812 8.59553 12.6222L3.18457 17.8656C3.16453 17.9011 3.13483 17.932 3.09801 17.9554C3.06119 17.9788 3.01836 17.9941 2.97321 18H0.384266Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6717_2184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(4.8833 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6717_2184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(9.76666 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6717_2184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(14.65 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_6717_2184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(0 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass4);
export default __webpack_public_path__ + "static/media/class-4.4492e46d79b5ff68593dd1bce1547956.svg";
export { ForwardRef as ReactComponent };